export const REPORT_MAP_PATCH_PROPERTIES_MAP = 'REPORT_MAP_PATCH_PROPERTIES_MAP';
export const REPORT_MAP_REPLACE_ALL_SITE_LOCAL_MAP = 'REPORT_MAP_REPLACE_ALL_SITE_LOCAL_MAP';
export const REPORT_MAP_UPDATE_MAP_DIALOG = 'REPORT_MAP_UPDATE_MAP_DIALOG';
